import { Button, Form, Input, Select, Modal, message, Spin } from "antd";
import React, { Component } from "react";
import { Radio } from "antd";
import no_addresses from "../../assets/no_addresses.svg";
import { DeleteFilled, EditFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import "./MyAddresses.scss";
import { addAddress, deleteAddress, fetchAddresses, fetchStates, updateAddress, selectAddress } from "../../network/profile.network";
import { connect } from "react-redux";
import { setAddressUser } from "../../redux/user/user.action";
import localization from '../../Localization/Localization.json'
const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
const states = [
  "Abu Dhabi",
  "'Ajman",
  "Al Fujayrah",
  "Sharjah",
  "Dubai",
  "Ra's al Khaymah",
  "Umm al Qaywayn",
];
class MyAddresses extends Component {
  formAddressRef = React.createRef();
  state = { 
    selectAddress: null,
    btnLoading: false,
    addressList : [],
    showAddAdress : false,
    statesList : [],
    isEditId : false,
    isLoading : true,
  };

  handelSetSelectAddress = (forceAddAdressLocal = false) => {
    const {addressList} = this.state;
    const selectedAddress =  addressList.find(address => address.selected === 1); 
    console.log(selectedAddress);
    this.setState({selectAddress : selectedAddress?.id || null})  
    forceAddAdressLocal && this.props.dispatch(setAddressUser(selectedAddress));
    !this.props.noSetAddressLocal && this.props.dispatch(setAddressUser(selectedAddress));  
  }

  onChangeAddress = (e) => {
    console.log("radio checked", e.target.value); 
    // this.setState({ selectAddress: e.target.value }); 
    confirm({ 
      title: localization.Addressbemain[this.props.currentLang],  
      okText : localization.OK[this.props.currentLang],
      cancelText : localization.Cancel[this.props.currentLang],
      icon: <ExclamationCircleOutlined />,
      onOk : () => {
          let body = new FormData();
          body.append("addressId", e.target.value); 
          selectAddress(
            body, 
            (res) => {
              console.log(res) 
              if(res.data.code === 200){ 
                message.success(res.data.message);
                fetchAddresses((res) => {
                  console.log(res.data.data.address);
                  this.setState({addressList : res.data.data.address}, () => this.handelSetSelectAddress(true) )
              }, (error) => {
                  console.log(error);
              })
              }
            },
            (error) => {
              console.log(error);  
              // this.setState({btnLoading : false})
            }
          );
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  componentDidMount() {
    fetchAddresses((res) => {
        console.log(res.data.data.address); 
        this.setState({isLoading : false}) 
        if(res.data.data.address.length > 0){
          this.setState({showAddAdress : true, })
        }
        this.setState({addressList : res.data.data.address}, () => this.handelSetSelectAddress() )
    }, (error) => {
        console.log(error);
        this.setState({isLoading : false}) 
    })
    fetchStates((res) => {
        console.log(res.data.data.countries);   
        this.setState({statesList : res.data.data.countries})
    }, (error) => {
        console.log(error);
    })
  }

  handelDltAddress = (e, address) => {
      e.stopPropagation(); 
      e.preventDefault();
      const {statesList} = this.state;
      const addressStr = address.city_name + ", Street No. " + address.street_number + ", floor " + address.floor + "," + address.floor;
        confirm({ 
        title: localization.DodeletetheseAddress[this.props.currentLang], 
        icon: <ExclamationCircleOutlined />,
        okText : localization.OK[this.props.currentLang],
        cancelText : localization.Cancel[this.props.currentLang],
        content: addressStr,
        onOk : () => {
            let body = new FormData();
            body.append("addressId", address.id);
            deleteAddress(
              body, 
              (res) => {
                // this.setState({btnLoading : false})
                console.log(res) 
                if(res.data.code === 200){ 
                  message.success(res.data.message);
                  fetchAddresses((res) => {
                    console.log(res.data.data.address); 
                    if(res.data.data.address.length > 0){
                      this.setState({showAddAdress : true})
                    }
                    this.setState({addressList : res.data.data.address}, () => this.handelSetSelectAddress() )
                }, (error) => {
                    console.log(error);
                })
                }
              },
              (error) => {
                console.log(error);  
                // this.setState({btnLoading : false})
              }
            );
        },
        onCancel() {
          console.log('Cancel');
        },
      });
  }

  handelEditAddress = (e, address) => { 
    e.stopPropagation(); 
    e.preventDefault();  
    console.log(address); 
    this.setState({isEditId : address.id})  
    this.formAddressRef.current.setFieldsValue({
      StreetNo : address?.street_number,
      Floor : address?.floor,
      Landmark : address?.landmark, 
      apartmentNumber : address?.apartment_number,
      Additionalnote : address?.note || "",
      City : address?.city_id,  
    });
  }


  
  onFinish = (values) => {
    this.setState({btnLoading : true})
    let body = new FormData();
    console.log(values)
    body.append("street_number", +values.StreetNo);
    body.append("floor", +values.Floor);
    body.append("landmark", values.Landmark); 
    body.append("note", values.Additionalnote || "");   
    body.append("city_id", values.City); 
    body.append("apartment_number", values.apartmentNumber);
    if(this.state.isEditId){
      body.append("addressId", +this.state.isEditId); 
      updateAddress( 
        body, 
        (res) => {
          this.setState({btnLoading : false, isEditId : false}) 
          if(res.data.code === 200){  
            message.success(res.data.message);
          }
          this.formAddressRef.current.resetFields();  
          fetchAddresses((res) => {
            this.setState({addressList : res.data.data.address}, () => this.handelSetSelectAddress(true) )
        }, (error) => {
            console.log(error);
        })
        },
        (error) => {
          console.log(error);  
          this.setState({btnLoading : false})
        }
      );
    }else{
    addAddress(
      body, 
      (res) => {
        this.setState({btnLoading : false})
        if(res.data.code === 200){ 
          message.success(res.data.message);
        }
        this.formAddressRef.current.resetFields();  
        fetchAddresses((res) => {
          console.log(res.data.data.address); 
          if(res.data.data.address.length > 0){
            this.setState({showAddAdress : true})
          }
          this.setState({addressList : res.data.data.address}, () => this.handelSetSelectAddress() )
      }, (error) => {
          console.log(error);
      })
      },
      (error) => {
        console.log(error);  
        this.setState({btnLoading : false})
      }
    );
  }
    
  };

  

  render() {
    const { selectAddress, btnLoading, addressList, showAddAdress, statesList, isEditId, isLoading } = this.state;
    const { currentLang } = this.props; 
    return (
      <Spin spinning={isLoading} >
      <div className="addresses-tab-wrapper"> 
          {addressList.length < 1 && !showAddAdress &&   
            <div className="no-address-holder">
            <img src={no_addresses} alt="no addresses" />
            <p>{localization.Youanyaddressyet[currentLang]}</p>
            <Button
                size="large"
                style={{ width: 200 }}
                type="primary"
                ghost
                onClick={() => this.setState({showAddAdress : true}) } 
            >
                + {localization.Addnew[currentLang]} 
            </Button>
            </div>
            } 
        {showAddAdress &&   
        <>
        <div className="address-list-wrapper">
          <Radio.Group
            size="large"
            // onChange={this.onChangeAddress}
            value={selectAddress}
          >
              {addressList.length > 0 && addressList.map(address => 
                    <Radio value={address.id} key={address.id} onClick={this.onChangeAddress}> 
                    <div className="address-radio-holder"> 
                        <p className="address--name">
                        {address.city_name + ", Street No. " + address.street_number + ", floor " + address.floor + "," + address.landmark }  
                        { ", " + address.note && address.note}  
                        </p> 
                        <div className="address-action-btn"> 
                        <DeleteFilled className="dlt-btn" onClick={(e) => this.handelDltAddress(e, address)} />
                        <EditFilled onClick={(e) => this.handelEditAddress(e, address)} />
                        </div>
                    </div>
                    </Radio>
                )}
          </Radio.Group>
        </div>

        <div className="add-address-wrapper">
            <h3 className="add-address-title">{localization.Addnewaddress[currentLang]}</h3>
          <div className="form-holder-2-col">
            <Form name="basic" ref={this.formAddressRef} onFinish={this.onFinish}>
              <Form.Item
                name="City" 
                label={localization.City[currentLang]}
                hasFeedback 
                rules={[
                  { required: true, message: localization.Pleaseselectyourcountry[currentLang] },
                ]}
                className="input-holder"
              >
                <Select placeholder={localization.City[currentLang]} size="large">
                  {statesList[0]?.cities?.map((state) => (
                    <Option value={state.id} key={state.id}>{state.name}</Option> 
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label={localization.StreetNo[currentLang]}
                name="StreetNo"
                rules={[
                  { required: true, message: localization.PleaseStreetNo[currentLang] },
                ]}
                className="input-holder" 
              >
                <Input type="number" placeholder={localization.StreetNo[currentLang]} />
              </Form.Item>

              <Form.Item
                label={localization.Floor[currentLang]}
                name="Floor" 
                rules={[
                  { required: true, message: localization.PleaseFloor[currentLang] },
                ]}
                className="input-holder" 
              >
                <Input type="number" placeholder={localization.Floor[currentLang]} /> 
              </Form.Item>
              <Form.Item
                label={localization.Landmark[currentLang]}
                name="Landmark"
                rules={[{ required: true, message: localization.PleaseLandmark[currentLang] }]}
                className="input-holder"
              > 
                <Input placeholder={localization.Landmark[currentLang]} /> 
              </Form.Item>

              <Form.Item
                label={localization.apartmentNumber[currentLang]}
                name="apartmentNumber" 
                rules={[
                  { required: true, message: localization.PleaseApartmentNumber[currentLang] },
                ]}
                className="input-holder" 
              >
                <Input type="number" placeholder={localization.apartmentNumber[currentLang]} /> 
              </Form.Item>

              <Form.Item
                label={localization.Additionalnote[currentLang]}
                name="Additionalnote" 
                className="input-holder"
                style={{gridColumn: "span 2"}} 
              >
                <TextArea autoSize={{ minRows: 4, maxRows: 4 }} placeholder={localization.Additionalnote[currentLang]} allowClear />
              </Form.Item>
            <div className="btn-action-holder" style={{gridColumn: "span 2"}} >
              {isEditId ?  
              <Button
              size="large"
              style={{ marginTop: 16 }}
              type="primary"
              htmlType="submit"
              loading={btnLoading}
              >
                {localization.Update[currentLang]} 
              </Button> :
              <Button
              size="large"
              style={{ marginTop: 16 }}
              type="primary"
              htmlType="submit"
              loading={btnLoading}
              >
                {localization.Save[currentLang]} 
              </Button>
              }
            </div>
            </Form> 
          </div>
        </div>
        </>
        }
      </div>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

export default connect(mapStateToProps)(MyAddresses);  
